import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { FaCheckCircle } from "react-icons/fa";
import { Button, Container, Modal, Form } from "react-bootstrap";

import { checkCookie, getCookie } from "../../Utils/Utils";
import Header from "../../Content/Header/Header";
import {
  ENABLE_RESONATE_WEBSITE,
  PLEDGE_AMOUNT,
  PLEDGE_API,
  PLEDGE_TOTAL_API,
} from "../../../constants/Constants";

require("./Pledge.scss");

const DEFAULT_PLEDGE_AMOUNT = Number(PLEDGE_AMOUNT[100] ?? Object.values(PLEDGE_AMOUNT)[0] ?? 0);

class Pledge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      isSubmitting: false,
      totalPledge: 0,
      pledge: {
        userId: "",
        pledgeAmount: DEFAULT_PLEDGE_AMOUNT,
      },
      pledgeMessage:
        DEFAULT_PLEDGE_AMOUNT > 0
          ? `Mission receives 🎁 ${this.formatCurrency(2 * DEFAULT_PLEDGE_AMOUNT)}`
          : "",
      showModal: false,
    };

    this.handlePledgeChange = this.handlePledgeChange.bind(this);
    this.handlePledgeSubmit = this.handlePledgeSubmit.bind(this);
  }

  componentDidMount() {
    if (!checkCookie("emailId") || !ENABLE_RESONATE_WEBSITE) {
      this.setState({ redirect: true });
      return;
    }

    const pledge = {
      ...this.state.pledge,
      userId: getCookie("userId"),
      pledgeAmount: DEFAULT_PLEDGE_AMOUNT,
    };

    this.setState(
      {
        pledge,
        pledgeMessage:
          DEFAULT_PLEDGE_AMOUNT > 0
            ? `Mission receives 🎁 ${this.formatCurrency(2 * DEFAULT_PLEDGE_AMOUNT)}`
            : "",
      },
      this.fetchTotalPledge
    );
  }

  fetchTotalPledge = () => {
    axios
      .get(PLEDGE_TOTAL_API)
      .then((response) => {
        this.setState({ totalPledge: Number(response.data) || 0 });
      })
      .catch(() => {
        this.setState({ totalPledge: 0 });
      });
  };

  handlePledgeChange(e) {
    let pledgeAmount = 0;

    if (e && e.target) {
      pledgeAmount = Number(e.target.value);
    } else {
      pledgeAmount = Number(e);
    }

    const pledge = {
      ...this.state.pledge,
      pledgeAmount,
    };

    this.setState({
      pledge,
      pledgeMessage:
        pledgeAmount > 0 ? `Mission receives 🎁 ${this.formatCurrency(2 * pledgeAmount)}` : "",
    });
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    }).format(amount);
  }

  handlePledgeSubmit() {
    const { pledge } = this.state;

    if (!pledge.userId || pledge.pledgeAmount <= 0) {
      return;
    }

    this.setState({ isSubmitting: true });

    axios
      .post(PLEDGE_API, pledge, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        this.setState(
          {
            showModal: true,
            pledge: {
              userId: pledge.userId,
              pledgeAmount: DEFAULT_PLEDGE_AMOUNT,
            },
            pledgeMessage:
              DEFAULT_PLEDGE_AMOUNT > 0
                ? `Mission receives 🎁 ${this.formatCurrency(2 * DEFAULT_PLEDGE_AMOUNT)}`
                : "",
            isSubmitting: false,
          },
          this.fetchTotalPledge
        );
      })
      .catch(() => {
        this.setState({ isSubmitting: false });
      });
  }

  render() {
    const { redirect, showModal, totalPledge, pledge, isSubmitting } = this.state;

    if (redirect) {
      return <Redirect to="/" />;
    }

    const totalImpact = totalPledge * 2;

    return (
      <div className="pledge-page-container pledge-page-container--redesign">
        <Modal show={showModal} centered>
          <Modal.Header className="pledge-modal">
            <Modal.Title>Thank You for Your Generosity!</Modal.Title>
          </Modal.Header>
          <Modal.Body className="pledge-modal">
            Your pledge is a powerful step toward making a meaningful difference.
          </Modal.Body>
          <Modal.Footer className="pledge-modal">
            <Button className="pledge-modal-button" onClick={() => this.setState({ showModal: false })}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Header />

        <Container className="pledge-content-container">
          <div className="pledge-hero">
            <div className="pledge-kicker">Resonate: Multiply Your Impact</div>
            <div className="pledge-title">Double Your Giving, Double Your Impact</div>
            <div className="pledge-sub-title">
              For a limited time, every dollar you give will be matched towards missions,
              making twice the difference up to $50,000!
            </div>
          </div>

          <div className="pledge-summary-card">
            <div className="pledge-summary-row">
              <span className="pledge-summary-emoji">🔥</span>
              <span>
                <strong>{this.formatCurrency(totalPledge)}</strong> of <strong>$50,000</strong> matched
              </span>
            </div>
            <div className="pledge-progress-track" aria-hidden="true">
              <div
                className="pledge-progress-fill"
                style={{ width: `${Math.min(100, Math.round((totalPledge / 50000) * 100))}%` }}
              />
            </div>
            <div className="pledge-progress-meta">
              <span>{this.formatCurrency(totalPledge)} raised</span>
              <span>{this.formatCurrency(totalImpact)} impact</span>
            </div>
            <div className="pledge-summary-note">
              Every dollar you pledge towards missions will be matched dollar-for-dollar up to a maximum of $50,000.
            </div>
          </div>
          <div className="pledge-card">
            <div className="pledge-card-title">Choose your pledge amount</div>

            <div className="pledge-option">
              {Object.keys(PLEDGE_AMOUNT).map((key) => {
                const amount = Number(PLEDGE_AMOUNT[key]);
                const isSelected = pledge.pledgeAmount === amount;
                const isPopular = amount === DEFAULT_PLEDGE_AMOUNT;

                return (
                  <Button
                    className={`pledge-option-value ${isSelected ? "is-selected" : ""}`}
                    key={key}
                    variant="light"
                    onClick={() => this.handlePledgeChange(amount)}
                    aria-pressed={isSelected}
                  >
                    <span className="pledge-option-amount">${amount}</span>
                    {isPopular && <span className="pledge-badge">Most Popular</span>}
                  </Button>
                );
              })}
            </div>
            <div className="pledge-option-other">
                <div className="pledge-option-other-label">Other:</div>
                <Form.Control
                    className="pledge-option-other-value"
                    type="number"
                    min="1"
                    placeholder="Enter amount"
                    value={
                    [50, 100, 250, 500].includes(pledge.pledgeAmount)
                        ? ""
                        : pledge.pledgeAmount || ""
                    }
                    onChange={this.handlePledgeChange}
                />
            </div>

            <div className="pledge-option-message">
              {pledge.pledgeAmount > 0
                ? `Your gift today will be doubled to ${this.formatCurrency(pledge.pledgeAmount * 2)} for mission work in India.`
                : "Choose an amount to see your matched impact."}
            </div>

            <Button
              className="pledge-button"
              onClick={this.handlePledgeSubmit}
              disabled={isSubmitting || !pledge.pledgeAmount}
            >
              {isSubmitting ? "Submitting..." : "Give Now & Double Your Impact"}
            </Button>

            <div className="pledge-button-note">Your gift will be doubled instantly</div>
          </div>

          <div className="pledge-details-grid">
            <div className="pledge-details-left">
              <div className="pledge-description-1">Your Pledge Supports:</div>
              <ul className="pledge-reasons">
                <li className="pledge-points">
                  <FaCheckCircle style={{ color: "darkgreen" }} /> 57 mission fields across India.
                </li>
                <li className="pledge-points">
                  <FaCheckCircle style={{ color: "darkgreen" }} /> Training and support for frontline workers.
                </li>
                <li className="pledge-points">
                  <FaCheckCircle style={{ color: "darkgreen" }} /> Church planting, and evangelism.
                </li>
              </ul>              
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default Pledge;
